import React from "react";

const MyloansStatement = () => {
  return <div>MyloansStatement</div>;
};

export default MyloansStatement;
